import { useState } from 'react'
import {
  useTable,
  useSortBy,
  usePagination,
  useGlobalFilter,
  useFilters,
} from 'react-table'
import GlobalFilter from './GlobalFilter'

const CustomDataTable = ({
  columns,
  data,
  getTrProps,
  IsPagingEnable = true,
  IsSearchEnable = true,
  buttonRow = null,
  searchLabel = '',
  minHeight = '350px',
}) => {
  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    prepareRow,
    page,
    canPreviousPage,
    canNextPage,
    pageOptions,
    pageCount,
    gotoPage,
    nextPage,
    previousPage,
    setPageSize,
    state: { pageIndex, pageSize },
    state,
    preGlobalFilteredRows,
    setGlobalFilter,
  } = useTable(
    {
      columns,
      data,
      initialState: { pageIndex: 0, pageSize: 5 },
    },
    useFilters,
    useGlobalFilter,
    useSortBy,
    usePagination
  )

  return (
    <div style={{ overflowX: 'auto', minHeight }}>
      {IsSearchEnable && (
        <>
          <GlobalFilter
            preGlobalFilteredRows={preGlobalFilteredRows}
            globalFilter={state.globalFilter}
            setGlobalFilter={setGlobalFilter}
          />
          <span style={{ float: 'right', margin: '8px' }}>{searchLabel}</span>
        </>
      )}

      {headerGroups.map((headerGroup) =>
        headerGroup.headers.map((column) =>
          column.Filter ? (
            <div key={column.id}>
              <label htmlFor={column.id}>{column.render('Header')}: </label>
              {column.render('Filter')}
            </div>
          ) : null
        )
      )}

      <table
        className="table striped bordered hover"
        {...getTableProps()}
        style={{ width: '100%' }} // let table grow naturally
      >
        <thead>
          {headerGroups.map((headerGroup) => (
            <tr {...headerGroup.getHeaderGroupProps()}>
              {headerGroup.headers.map((column) => (
                <th {...column.getHeaderProps(column.getSortByToggleProps())}>
                  {column.render('Header')}
                  <span>
                    {column.isSorted
                      ? column.isSortedDesc
                        ? ' ▼'
                        : ' ▲'
                      : ''}
                  </span>
                </th>
              ))}
            </tr>
          ))}
        </thead>
        <tbody {...getTableBodyProps()}>
          {page && page.length > 0 ? (
            page.map((row) => {
              prepareRow(row)
              return (
                <tr
                  {...row.getRowProps()}
                  style={{ cursor: 'pointer' }}
                  className="table-hover-class"
                  onDoubleClick={(event) => getTrProps(event, row.original)}
                >
                  {row.cells.map((cell) => (
                    <td {...cell.getCellProps()}>{cell.render('Cell')}</td>
                  ))}
                </tr>
              )
            })
          ) : (
            <tr>
              <td colSpan={headerGroups[0].headers.length} style={{ textAlign: 'center' }}>
                No record found
              </td>
            </tr>
          )}
          {buttonRow && (
            <tr>
              <td colSpan={headerGroups[0].headers.length}>{buttonRow}</td>
            </tr>
          )}
        </tbody>
      </table>

      {IsPagingEnable && (
        <ul className="pagination float-right pagination-scroll">
          <select
            className="form-control"
            value={pageSize}
            onChange={(e) => setPageSize(Number(e.target.value))}
            style={{ width: '120px', height: '38px' }}
          >
            {[5, 10, 20, 30, 40, 50].map((size) => (
              <option key={size} value={size}>
                Show {size}
              </option>
            ))}
          </select>
          <li className="page-item pointer" onClick={() => gotoPage(0)} disabled={!canPreviousPage}>
            <a className="page-link">&laquo;</a>
          </li>
          <li className="page-item pointer" onClick={() => previousPage()} disabled={!canPreviousPage}>
            <a className="page-link">&lt;</a>
          </li>
          <li className="page-item pointer" onClick={() => nextPage()} disabled={!canNextPage}>
            <a className="page-link">&gt;</a>
          </li>
          <li className="page-item pointer" onClick={() => gotoPage(pageCount - 1)} disabled={!canNextPage}>
            <a className="page-link">&raquo;</a>
          </li>
          <li>
            <a className="page-link" style={{ width: '125px' }}>
              Page <strong>{pageIndex + 1} of {pageOptions.length}</strong>
            </a>
          </li>
          <li>
            <a className="page-link">
              <input
                className="form-control"
                type="number"
                defaultValue={pageIndex + 1}
                onChange={(e) => gotoPage(e.target.value ? Number(e.target.value) - 1 : 0)}
                style={{ width: '100px', height: '20px' }}
              />
            </a>
          </li>
        </ul>
      )}
    </div>
  )
}

export default CustomDataTable
